export default {
  data: [],
  loading: false,
};
